import React from 'react';
import MarketingHeader from '../components/marketing/MarketingHeader';
import MarketingFooter from '../components/marketing/MarketingFooter';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <MarketingHeader />
      <main className="pt-20">
        <section className="py-16 bg-gray-50 dark:bg-slate-800">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-lg p-8 md:p-12">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
                Terms of Use
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mb-8">
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>

              <div className="prose prose-lg dark:prose-invert max-w-none">
                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">1. Acceptance of Terms</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    By accessing and using Fitzaa, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">2. Use License</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    Permission is granted to temporarily access the materials on Fitzaa's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                    <li>Modify or copy the materials</li>
                    <li>Use the materials for any commercial purpose or for any public display</li>
                    <li>Attempt to reverse engineer any software contained on Fitzaa's website</li>
                    <li>Remove any copyright or other proprietary notations from the materials</li>
                    <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">3. User Accounts</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">4. Acceptable Use</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    You agree not to use the service:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                    <li>In any way that violates any applicable national or international law or regulation</li>
                    <li>To transmit, or procure the sending of, any advertising or promotional material without our prior written consent</li>
                    <li>To impersonate or attempt to impersonate the company, a company employee, another user, or any other person or entity</li>
                    <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">5. Intellectual Property</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    The service and its original content, features, and functionality are and will remain the exclusive property of Fitzaa and its licensors. The service is protected by copyright, trademark, and other laws. Our trademarks may not be used in connection with any product or service without our prior written consent.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">6. Disclaimer</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    The materials on Fitzaa's website are provided on an 'as is' basis. Fitzaa makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">7. Limitations</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    In no event shall Fitzaa or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Fitzaa's website, even if Fitzaa or a Fitzaa authorized representative has been notified orally or in writing of the possibility of such damage.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">8. Revisions</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    Fitzaa may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">9. Governing Law</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    These terms and conditions are governed by and construed in accordance with applicable laws. Any disputes relating to these terms and conditions will be subject to the exclusive jurisdiction of the courts in the jurisdiction where Fitzaa operates.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">10. Contact Information</h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                    If you have any questions about these Terms of Use, please contact us at:
                  </p>
                  <p className="text-gray-700 dark:text-gray-300">
                    Email: <a href="mailto:sales@fitzaa.life" className="text-purple-600 dark:text-purple-400 hover:underline">sales@fitzaa.life</a>
                  </p>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
};

export default TermsOfUsePage;


